import * as React from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { animated } from 'react-spring';

import { SiteContext } from '../../../../utils/context/SiteContext';

import { Container } from '../../../layout/Container';

import { Heading } from '../../../ui/text/Heading';
import { Paragraph } from '../../../ui/text/Paragraph';

import { useFadeTransition } from '../../../../utils/hooks/useFadeTransition';
import { Seo } from '../../../../utils/seo/Index';

import { BaseHeroContent, Hero } from '../../../ui/hero/Index';

const TilrettelagtBoligsalg: React.FC = () => {
  const location = useLocation();
  const { routeConfig } = React.useContext(SiteContext);

  const { fadeIn: pageFadeIn } = useFadeTransition({
    immidiate: true
  });

  return (
    <>
      <Seo
        title="Eiendomssalg tilrettelagt mot smittefare - PrivatMegleren"
        description="Vi har tilrettelagt for trygge visninger med så lav smitterisiko som mulig"
        url={location.pathname}
      />
      <Hero
        imageUrl="https://cdn.reeltime.no/pm_assets/content/tilrettelagt_boligsalg.jpeg"
        opacity={0.4}
        height="500px"
        className="top-header-margin"
        alt="bilde"
      >
        <HeroContent style={pageFadeIn}>
          <Heading tag="h1" center>
            Eiendomssalg tilrettelagt
            <br /> mot smittefare
          </Heading>
          <Paragraph center>
            Vi har tilrettelagt for trygge visninger med så lav smitterisiko som
            mulig. Fellesvisninger med mange deltakere unngås og erstattes av
            mindre grupper med påmeldte besøkende.
          </Paragraph>
        </HeroContent>
      </Hero>
      <Container style={{ ...pageFadeIn, paddingTop: '40px' }}>
        <Paragraph center>
          - Visning tilrettelegges for god håndhygiene med såpe, Antibac e.l.
          ved inngangsdør.{' '}
        </Paragraph>
        <Paragraph center>
          - Fellesvisninger med mange deltakere unngås og erstattes av mindre
          grupper med påmeldte besøkende.
        </Paragraph>
        <Paragraph center>
          - Besøkende skal unngå å ta på ting i eiendommen. Megler hjelper
          gjerne til med dette.
        </Paragraph>
        <Paragraph center>
          - Interessenter som er smittet eller som har oppholdt seg i
          risikosoner, kan ikke delta på visning, men kan sende en annen og se
          bilder og video.
        </Paragraph>
        <Paragraph center>
          - Kundemøter avholdes på Skype eller FaceTime hvis ønskelig. - Avtaler
          og kontrakter signeres digitalt.
        </Paragraph>
        <Paragraph center>
          - Trykte salgsoppgaver erstattes med digitale.
        </Paragraph>
        <Paragraph center>
          Kontakt gjerne en av{' '}
          <a href={routeConfig.officeBrokerSearch.url}>våre meglere</a> hvis du
          har spørsmål.
        </Paragraph>
        <Paragraph center>
          For øvrig ber vi alle vennligst om å forholde seg til FHIs råd om
          Coronaviruset.
        </Paragraph>
      </Container>
    </>
  );
};

export default TilrettelagtBoligsalg;

const HeroContent = styled(animated.div)`
  ${BaseHeroContent}
  flex-flow: column;
  max-width: 700px;
`;
